'use strict';

bbw.model.Contacts = ngtk.model.Base.extend({

    statics: {
        FOLDERS: ['main', 'fav'],
        FOLDERS_ALL: ['main', 'fav', 'trash']
    },

    ON_CONTACTS_UPDATED_EVENT: 'bbw.model.contacts.updated',

    _data: null,
    _usersCache: null,
    _contactByUserIdMap: null,
    _updateContactsQueue: null,
    _contactsReadyDeferred: null,
    _updateContactsFromResponseSequence: 0,
    _allowsPrivatePhotosByDefault: undefined,

    _initialize: function() {
        this._data = {
            contacts: [],
            folders: {},
            trash: {},
            unread_messages_count: 0
        };
        bbw.model.Contacts.FOLDERS.forEach(function(folderName) {
            this._data.folders[folderName] = {unread_count: 0};
        }.bind(this));
        this._usersCache = {};
        this._contactByUserIdMap = {};
        this._updateContactsQueue = [];
        this._loaded = false;
    },

    onContactsUpdated: function($scope, cb) {
        $scope.$on(this.ON_CONTACTS_UPDATED_EVENT, cb);
    },

    _onContactsUpdated: function() {
        if (this._scope && this._scope.$root) {
            this._scope.$root.$broadcast(this.ON_CONTACTS_UPDATED_EVENT);
        }
    },

    waitForContactsReady: function() {
        if (this._loaded) {
            return this.$q.when();
        }
        this._updateAllowsPhotosByDefault();
        this._contactsReadyDeferred = this.$q.defer();
        this.initContactsFromApi();
        return this._contactsReadyDeferred.promise;
    },

    updateUnreadMessagesCount: function(count) {
        count = parseInt(count);
        if (isNaN(count)) {
            count = 0;
        }
        this._data.unread_messages_count = count;
    },

    getUnreadCount: function() {
        return this._data.unread_messages_count;
    },

    initContactsFromApi: function() {
        this.updateContactsFromApi(true);
    },

    updateContactsFromApi: function(reloadExistingContactsData) {
        this._updateContactsQueue.push(this._doUpdateContactsFromApi.bind(this, reloadExistingContactsData));
        this._runQueuedContactUpdates();
    },

    _updateAllowsPhotosByDefault: function() {
        return this._api.request('get', 'chat/allows-private-photos').execute().then(function(response) {
            this._allowsPrivatePhotosByDefault = response.result.is_allowed;
        }.bind(this));
    },

    _doUpdateContactsFromApi: function(reloadExistingContactsData) {
        if (angular.isUndefined(reloadExistingContactsData)) {
            reloadExistingContactsData = true;
        }
        var lastUpdateContactsFromResponseSequence = this._updateContactsFromResponseSequence;

        return this._api.request('get', 'chat/get-contacts').execute().then(
            function(response) {
                if (this._updateContactsFromResponseSequence == lastUpdateContactsFromResponseSequence) {
                    this._updateAllowsPhotosByDefault();
                    return this.setContactsFromResponse(response, reloadExistingContactsData)
                }
            }.bind(this)
        );
    },

    addContact: function(contact_user_id) {
        return this._api.request('post', 'chat/add-contact', {contact_user_id: contact_user_id}).execute();
    },

    moveContacts: function(contacts, folder, reloadTrash) {
        var ids = [];
        contacts.forEach(function(contact) {
            if (contact.folder != folder) {
                ids.push(contact.user_id);
                contact.is_moving = true;
            }
        });
        return this._moveContactsByIds(ids, folder).finally(function() {
            contacts.forEach(function(contact) {
                delete contact.is_moving;
            });
            if (folder === 'trash' || reloadTrash) {
                this.loadTrashContacts();
            }
        }.bind(this));
    },

    deleteContact: function(contact) {
        contact.is_moving = true;
        return this._api.request('post', 'chat/delete-contact', {
            contact_user_id: contact.user_id
        }).execute().then(function() {
            contact.is_deleted = true;
            var idx = this._data.trash.contacts.indexOf(contact);
            if (~idx) {
                this._data.trash.contacts.splice(idx, 1);
            }
        }.bind(this)).finally(function() {
            delete contact.is_moving;
        }.bind(this));
    },

    trashContact: function(contact) {
        return this._trashContact(contact);
    },

    denyContact: function(contact) {
        return this._trashContact(contact, 'deny');
    },

    banContact: function(contact, abuse) {
        var abuse_reason = undefined, abuse_desc = undefined;
        if (abuse) {
            abuse_reason = abuse.getReason();
            abuse_desc = abuse.getDesc();
        }
        return this._trashContact(contact, 'ban', abuse_reason, abuse_desc);
    },

    _trashContact: function(contact, type, abuse_reason, abuse_desc) {
        contact.is_moving = true;
        var was_trashed = contact.is_trashed;
        return this._api.request('post', 'chat/trash-contact', {
            contact_user_id: contact.user_id,
            type: type || null,
            abuse_reason: abuse_reason,
            abuse_desc: abuse_desc
        }).execute().then(function(response) {
            contact.is_trashed = true;
            contact.relation = response.relation;
            if (!was_trashed || contact.relation !== 'contact') {
                this.loadTrashContacts();
            }
        }.bind(this)).finally(function() {
            contact.is_moving = false;
        }.bind(this));
    },

    _moveContactsByIds: function(contact_user_ids, folder) {
        if (!angular.isArray(contact_user_ids) || !contact_user_ids.length) {
            return this.$q.when();
        }
        return this._api.request('post', 'chat/move-contacts', {
            contact_user_ids: contact_user_ids,
            folder: folder
        }).execute();
    },

    isAllowedPrivatePhotosToContact: function(contact) {
        if (angular.isObject(contact) && angular.isDefined(contact.allow_private_photos)) {
            return contact.allow_private_photos;
        } else {
            return this._allowsPrivatePhotosByDefault;
        }
    },

    allowPrivatePhotos: function(contact, is_allowed) {
        if (angular.isDefined(is_allowed)) {
            is_allowed = !!is_allowed;
        } else {
            is_allowed = true;
        }
        contact.is_moving = true;
        return this._api.request('post', 'chat/allow-private-photos', {
            contact_user_id: contact.user_id,
            allow: is_allowed
        }).execute().finally(function() {
            delete contact.is_moving;
        });
    },

    initUnreadCountFromApi: function() {
        return this._api.request('get', 'chat/get-unread-count').execute().then(function(response) {
            this.updateUnreadMessagesCount(response.unread_messages_count);
        }.bind(this));
    },

    createTemporaryContactById: function(user_id) {
        var existingContact = this.findContactById(user_id);
        if (existingContact) {
            return this.$q.when(existingContact);
        }
        var temporaryContact = {
            user_id: user_id,
            relation: 'contact',
            relation_inverse: 'contact',
            folder: 'main',
            $$temporary: true
        };
        return this._getUserProfilesByIds([user_id]).then(function(response) {
            if (!response.items || response.items.length != 1) {
                return this.$q.reject('user_not_found')
            }
            temporaryContact.user = response.items[0];
            this._contactByUserIdMap[user_id] = temporaryContact;
            this._data.contacts.unshift(temporaryContact);
            return temporaryContact;
        }.bind(this));
    },

    findContactById: function(user_id) {
        var contact = this._contactByUserIdMap[user_id];
        if (contact && !contact.$$deleted) {
            return contact;
        } else {
            return undefined;
        }
    },

    updateContactLastSerial: function(user_id, serial) {
        if (!this._contactByUserIdMap[user_id]) {
            return;
        }
        var contact = this._contactByUserIdMap[user_id];
        contact.last_serial = serial;
        var contacts = this._data.contacts;
        if (angular.isArray(contacts) && ~contacts.indexOf(contact)) {
            this._sortContacts(this._data.contacts);
            this._removeFromTrash(contact);
            this._onContactsUpdated();
        }
    },

    setContactsFromResponse: function(responseData, reloadExistingContactsData) {
        this._updateContactsQueue.push(
            this._updateContactsFromResponse.bind(this, responseData, reloadExistingContactsData)
        );
        this._runQueuedContactUpdates();
    },

    _runQueuedContactUpdates: function() {
        var nextElement = this._updateContactsQueue.shift();
        if (!nextElement) {
            return this.$q.when(true);
        }
        if (angular.isUndefined(this._updateContactsQueue.deferred)) {
            this._updateContactsQueue.deferred = this.$q.defer();
        }
        var resolve = function() {
            if (this._updateContactsQueue.deferred) {
                this._updateContactsQueue.deferred.resolve();
                delete this._updateContactsQueue.deferred;
            }
        }.bind(this);
        nextElement().then(function() {
            if (this._updateContactsQueue.length) {
                this._runQueuedContactUpdates();
            } else {
                resolve();
            }
        }.bind(this));
        return this._updateContactsQueue.deferred.promise;
    },

    _decodeContactResponse: function(folder, response) {
        var allowPrivatePhotos;
        if (angular.isUndefined(response[5]) || null === response[5]) {
            allowPrivatePhotos = undefined;
        } else {
            allowPrivatePhotos = !!response[5];
        }

        return {
            folder: folder,
            user_id: response[0],
            relation: response[1],
            relation_inverse: response[2] || 'contact',
            messages_count_unread: response[3],
            last_serial: response[4],
            allow_private_photos: allowPrivatePhotos
        };
    },

    touch: function() {
        this._updateContactsFromResponseSequence++;
    },

    _updateContactsFromResponse: function(responseData, reloadExistingContactsData) {
        this.touch();
        var chatFolderNames = bbw.model.Contacts.FOLDERS;
        if (angular.isDefined(responseData.unread_messages_count)) {
            this.updateUnreadMessagesCount(responseData.unread_messages_count);
        }
        var contacts = [];
        chatFolderNames.forEach(function(folderName) {
            var responseFolderContacts = angular.isObject(responseData.contacts)
                ? responseData.contacts[folderName]
                : undefined;
            this._data.folders[folderName].unread_count = responseFolderContacts ? responseFolderContacts.unread_count : 0;
            if (responseFolderContacts && angular.isArray(responseFolderContacts.contacts)) {
                contacts = contacts.concat(responseFolderContacts.contacts.map(this._decodeContactResponse.bind(this, folderName)));
            }
        }.bind(this));
        return this._loadUserData(contacts, reloadExistingContactsData).then(function() {
            var existingContactUserIdMap = {};
            this._data.contacts.forEach(function(contact, index) {
                existingContactUserIdMap[contact.user_id] = index;
            });
            var userIds = [];
            contacts.forEach(function(contact) {
                userIds.push(contact.user_id);
                var existingContactIndex = existingContactUserIdMap[contact.user_id];
                if (angular.isDefined(existingContactIndex)) {
                    var existingLastSerial = this._data.contacts[existingContactIndex].last_serial;
                    if (contact.last_serial < existingLastSerial) {
                        contact.last_serial = existingLastSerial;
                    }
                    if (this._data.contacts[existingContactIndex].is_trashed) {
                        contact.is_trashed = true;
                    }
                    ngtk.tools.object.replace(this._data.contacts[existingContactIndex], contact);
                } else {
                    if (this._contactByUserIdMap[contact.user_id]) {
                        delete this._contactByUserIdMap[contact.user_id].$$deleted;
                        var existingContactInAnotherFolder = this._contactByUserIdMap[contact.user_id];
                        if (existingContactInAnotherFolder.$$temporary) {
                            delete existingContactInAnotherFolder.$$temporary;
                        }
                        if (existingContactInAnotherFolder.is_trashed) {
                            this._removeFromTrash(existingContactInAnotherFolder);
                        }
                        existingLastSerial = existingContactInAnotherFolder.last_serial;
                        if (contact.last_serial < existingLastSerial) {
                            contact.last_serial = existingLastSerial;
                        }
                        contact = ngtk.tools.object.replace(existingContactInAnotherFolder, contact);
                    }
                    this._data.contacts.push(contact);
                }
            }.bind(this));
            var contactIdsFoundMap = {};
            for (var index = 0; index < this._data.contacts.length;) {
                var contact = this._data.contacts[index];
                if (!~userIds.indexOf(contact.user_id)) {
                    this._data.contacts.splice(index, 1);
                } else {
                    contactIdsFoundMap[contact.user_id] = true;
                    this._contactByUserIdMap[contact.user_id] = contact;
                    ++index;
                }
            }
            this._sortContacts(this._data.contacts);
            this._data.contacts.forEach(function(contact) {
                contactIdsFoundMap[contact.user_id] = true;
            }.bind(this));

            if (this._data.trash.contacts) {
                this._data.trash.contacts.forEach(function(contact) {
                    contactIdsFoundMap[contact.user_id] = true;
                });
            }
            for (var key in this._contactByUserIdMap) {
                if (this._contactByUserIdMap.hasOwnProperty(key) && !contactIdsFoundMap[key] && !this._contactByUserIdMap[key].is_trashed) {
                    this._contactByUserIdMap[key].$$deleted = true;
                }
            }
            this._loaded = true;
            if (this._contactsReadyDeferred) {
                this._contactsReadyDeferred.resolve();
                this._contactsReadyDeferred = undefined;
            }
            this._onContactsUpdated();
        }.bind(this));
    },

    _loadUserData: function(contacts, reloadExistingContactsData) {
        var user_ids = [], load_user_ids = [];
        contacts.forEach(function(contact) {
            if (contact.user_id && !~user_ids.indexOf(contact.user_id)) {
                user_ids.push(contact.user_id);
                if (reloadExistingContactsData || angular.isUndefined(this._usersCache[contact.user_id])) {
                    load_user_ids.push(contact.user_id);
                }
            }
        }.bind(this));
        return this._getUserProfilesByIds(load_user_ids).then(function(response) {
            if (response && response.count && angular.isArray(response.items)) {
                response.items.forEach(function(user_data) {
                    var user_id = user_data.id;
                    if (angular.isDefined(user_id)) {
                        if (angular.isObject(this._usersCache[user_id])) {
                            ngtk.tools.object.replace(this._usersCache[user_id], user_data);
                        } else {
                            this._usersCache[user_id] = user_data;
                        }
                    }
                }.bind(this));
            }
        }.bind(this)).then(function() {
            contacts.forEach(function(contact) {
                contact.user = this._usersCache[contact.user_id];
            }.bind(this));
            return user_ids;
        }.bind(this));
    },

    _getUserProfilesByIds: function(load_user_ids) {
        if (!load_user_ids.length) {
            return this.$q.when(null);
        } else {
            return this._api.request('get', 'user/profiles/' + load_user_ids.join(',') + '/1').execute();
        }
    },

    _sortContacts: function(contacts) {
        var intval = function(n) {
            if (n === true) {
                return 1;
            }
            if (n === false) {
                return 0;
            }
            if (angular.isUndefined(n)) {
                return 0;
            }
            n = parseInt(n);
            return isNaN(n) ? 0 : n;
        };

        contacts.sort(function(b, a) {
            var a_tmp = a.$$temporary ? 1 : 0;
            var b_tmp = b.$$temporary ? 1 : 0;
            if (a_tmp != b_tmp) {
                return a_tmp - b_tmp;
            }

            var a_serial = angular.isDefined(a.last_serial) ? a.last_serial : 0;
            var b_serial = angular.isDefined(b.last_serial) ? b.last_serial : 0;
            if (a_serial != b_serial) {
                return a_serial - b_serial;
            }
            var a_unread = angular.isDefined(a.messages_count_unread) ? a.messages_count_unread : 0;
            var b_unread = angular.isDefined(b.messages_count_unread) ? b.messages_count_unread : 0;
            if (a_unread != b_unread) {
                return a_unread - b_unread;
            }

            var a_online = intval((angular.isDefined(a.user) && angular.isDefined(a.user.online_status))
                ? a.user.online_status.is_online : false);
            var b_online = intval((angular.isDefined(b.user) && angular.isDefined(b.user.online_status))
                ? b.user.online_status.is_online : false);

            if (a_online != b_online) {
                return a_online - b_online;
            }

            var a_online_at = (angular.isDefined(a.user) && angular.isDefined(a.user.online_status))
                ? intval(a.user.online_status.last_visited) : 0;
            var b_online_at = (angular.isDefined(b.user) && angular.isDefined(b.user.online_status))
                ? intval(b.user.online_status.last_visited) : 0;

            return b_online_at - a_online_at;
        });
        return contacts;
    },

    loadTrashContacts: function() {
        this._updateContactsQueue.push(this._loadTrashContacts.bind(this));
        return this._runQueuedContactUpdates();
    },

    _loadTrashContacts: function() {
        this._data.trash.loading = true;
        return this._api.request('get', 'chat/get-contacts-trashed').execute().then(function(response) {
            var trashed_contacts = (response && angular.isArray(response.trashed_contacts)) ? response.trashed_contacts : [];
            var trashedContactsByUserIdMap = {};
            if (!trashed_contacts.length) {
                ngtk.tools.object.replace(this._data.trash, {contacts: []});
            } else {
                trashed_contacts.forEach(function(contact, index) {
                    contact.is_trashed = true;
                    contact.$$_index = index;
                    trashedContactsByUserIdMap[contact.user_id] = contact;
                });
                return this._getUserProfilesByIds(Object.keys(trashedContactsByUserIdMap)).then(function(response) {
                    if (response && response.count && angular.isArray(response.items)) {
                        response.items.forEach(function(user_data) {
                            var user_id = user_data.id;
                            if (angular.isDefined(user_id) && angular.isDefined(trashedContactsByUserIdMap[user_id])) {
                                trashedContactsByUserIdMap[user_id].user = user_data;
                                if (this._contactByUserIdMap[user_id]) {
                                    delete this._contactByUserIdMap[user_id].$$deleted;
                                    delete this._contactByUserIdMap[user_id].$$temporary;
                                    var index = trashedContactsByUserIdMap[user_id].$$_index;
                                    trashed_contacts[index] = trashedContactsByUserIdMap[user_id] = ngtk.tools.object.replace(
                                        this._contactByUserIdMap[user_id],
                                        trashedContactsByUserIdMap[user_id]
                                    );
                                } else {
                                    this._contactByUserIdMap[user_id] = trashedContactsByUserIdMap[user_id];
                                }
                            }
                        }.bind(this));
                    }
                    ngtk.tools.object.replace(this._data.trash, {
                        contacts: trashed_contacts.filter(function(contact) {
                            delete contact.$$_index;
                            return !contact.is_deleted;
                        })
                    });
                }.bind(this));
            }
            angular.forEach(this._contactByUserIdMap, function(contact, user_id) {
                if (angular.isUndefined(trashedContactsByUserIdMap[user_id])) {
                    this._removeFromTrash(contact);
                }
            }.bind(this));
            this._onContactsUpdated();
        }.bind(this)).finally(function() {
            delete this._data.trash.loading;
        }.bind(this));
    },

    _removeFromTrash: function(contact) {
        delete contact.is_trashed;
        delete contact.is_deleted;
        if (this._data.trash.contacts) {
            var index = this._data.trash.contacts.indexOf(contact);
            if (!!~index) {
                this._data.trash.contacts.splice(index, 1);
            }
        }
    },

    get: function() {
        return this._data;
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
    }

});
